import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import useFreaksT from './useFreaksT';
import { STAT_ICONS } from './statIcons';
import { freaksSx as s, tonalSx } from './freaksStyles';

/** Live effect of a stat beyond its weight in actions: shorter injuries, more base income. */
const statEffect = (stat, state, t) => {
  if (stat === 'endurance' && state.injuryReduction) {
    return t('theFreaks.statEffects.endurance', { percent: Math.round(state.injuryReduction * 100) });
  }
  if (stat === 'charisma' && state.baseBonus) {
    return t('theFreaks.statEffects.charisma', { percent: Math.round(state.baseBonus * 100) });
  }
  return null;
};

// Each stat has a job: its action counts it double (skill: missions, strength: attack,
// endurance: defence + shorter injuries, charisma: base income).
export default function FreaksTraining({ state, energy, disabled, onTrain }) {
  const { t } = useFreaksT();
  return (
    <Box data-testid="freaks-training">
      {state.powers ? (
        <Box sx={{ mb: 1.25, color: 'white' }} data-testid="freaks-powers">
          <Typography sx={s.bold}>{t('theFreaks.train.powers', state.powers)}</Typography>
          <Typography sx={{ ...s.small, ...s.muted }}>{t('theFreaks.train.powersHint')}</Typography>
        </Box>
      ) : null}
      {state.stats.map(({ stat, value, withGear, trainPrice }) => {
        const Icon = STAT_ICONS[stat] ?? STAT_ICONS.charisma;
        const effect = statEffect(stat, state, t);
        return (
          <Box key={stat} sx={{ ...s.card, ...s.between }}>
            <Icon sx={{ fontSize: 28, color: DEFAULT_THEME_COLOR }}/>
            <Box sx={s.grow}>
              <Typography sx={s.title}>{t(`theFreaks.stats.${stat}`)} · {value}</Typography>
              <Typography sx={{ ...s.small, ...s.muted }}>{t(`theFreaks.statHints.${stat}`)}</Typography>
              {withGear > value
                ? <Typography sx={{ ...s.small, color: DEFAULT_THEME_COLOR }}>{t('theFreaks.train.withGear', { value: withGear })}</Typography>
                : null}
              {effect ? <Typography sx={{ ...s.small, color: DEFAULT_THEME_COLOR }}>{effect}</Typography> : null}
              <Typography sx={s.small}>{t('theFreaks.train.cost', { price: trainPrice, energy: state.trainEnergy })}</Typography>
            </Box>
            <Button
              data-testid={`freaks-train-${stat}`}
              disabled={disabled || state.cash < trainPrice || energy < state.trainEnergy}
              onClick={() => onTrain(stat)}
              sx={tonalSx}
            >
              {t('theFreaks.train.button')}
            </Button>
          </Box>
        );
      })}
    </Box>
  );
}
